import React from "react";
import PropTypes from "prop-types";
import { SFStack } from "../../../grid";
import CopilotAction from "../../renderers/copilot";
import MinMaxAction from "../../renderers/minMax";
import CloseAction from "../../renderers/close";
import { ACTION_NAMES } from "../../../../constants/actionBar";
import getStyled from "../../../../hooks/getStyled";

const { COPILOT, MIN_MAX, CLOSE } = ACTION_NAMES;

const { styled } = getStyled();

const AddOnActionWrapper = styled(SFStack, {
  shouldForwardProp: (prop) => prop !== "disablePaddingRight",
})(({ theme, disablePaddingRight = false }) => ({
  height: "48px",
  borderLeft: `1px solid ${theme.palette.grey100.main}`,
  paddingLeft: "10px",
  ...(!disablePaddingRight && { paddingRight: "10px" }),
}));

const NAME_TO_COMPONENT_MAP = {
  [COPILOT]: CopilotAction,
  [MIN_MAX]: MinMaxAction,
  [CLOSE]: CloseAction,
};

const AddOnActionGroup = ({ actionDefs = [] }) => {
  if (actionDefs.length === 0) {
    // If there are no add-on action definitions, return null
    return null;
  }

  return (
    <SFStack direction="row" alignItems="center">
      {actionDefs.map((actionDef, index) => {
        const { name } = actionDef;
        const Component = NAME_TO_COMPONENT_MAP[name];
        return (
          actionDef && (
            <AddOnActionWrapper
              key={actionDef.name}
              alignItems="center"
              justifyContent="center"
              // Disable padding right for the last add-on
              disablePaddingRight={index === actionDefs.length - 1}
            >
              <Component
                onClick={actionDef.onClick}
                disabled={actionDef.disabled}
                active={actionDef.active}
              />
            </AddOnActionWrapper>
          )
        );
      })}
    </SFStack>
  );
};

export default AddOnActionGroup;

AddOnActionGroup.propTypes = {
  actionDefs: PropTypes.arrayOf(
    PropTypes.shape({
      // The name of the action
      name: PropTypes.oneOf([COPILOT, MIN_MAX, CLOSE]).isRequired,
      // The function to call when the add-on is clicked
      onClick: PropTypes.func.isRequired,
    })
  ),
};
